<script lang="ts" setup>
import type { ParagraphScrollytellingFragment } from '#graphql-operations'
import initScrollyTelling from './scripts/scrollytelling'

defineProps<ParagraphScrollytellingFragment>()

defineBlokkli({
  bundle: 'scrollytelling',
})

declare global {
  interface Window {
    gsap: any;
    ScrollTrigger: any;
  }
}

const { load: loadGsap, onLoaded, status: statusGsap } = useScript(
  "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.0/gsap.min.js",
  {
    bundle: true,
    use() {
      return {
        gsap: window.gsap,
      };
    },
  }
);

const { load: loadScrollTrigger, onLoaded: onLoadedScrollTrigger, status: statusScrollTrigger } = useScript(
  "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.0/ScrollTrigger.js",
  {
    bundle: true,
    use() {
      return {
        ScrollTrigger: window.ScrollTrigger,
      };
    },
  }
);

onMounted(() => {

  onLoaded(({ gsap }) => {
    loadScrollTrigger();
  });

  onLoadedScrollTrigger(({ ScrollTrigger }) => {
    if (typeof initScrollyTelling === 'function') {
      initScrollyTelling();
    }
  });

});

</script>

<template>
  <div class="Scrollytelling etx-container Container pv-0" id="ScrollytellingLogo">

    <div class="etx-center Center">

      <div class="Scrollytelling__canvas">

        <div class="Scrollytelling__canvas__ratio">
          <ClientOnly>
            <canvas></canvas>
          </ClientOnly>
        </div>

        <div class="etx-flex Flex gv-0 gh-0">

          <div class="etx-flex__item Flex__item mob-l:ml-1 mob-l:mr-1 tab-l:mr-2">

            <div class="Scrollytelling__content_section" id="part1">
              <div class="etx-text Text">
                <h2 class="font-h3 font-color-primary" v-if="title1">{{ title1 }}</h2>
                <p class="font-h3 alt" v-if="subline1">{{ subline1 }}</p>
                <HelperHtmlRenderer v-if="lead1" :htmlContent="lead1" :additionalClasses="'font-lead'" />
                <HelperHtmlRenderer v-if="text1" :htmlContent="text1" />
              </div>
            </div>

            <div class="Scrollytelling__content_section" id="part2">
              <div class="etx-text Text">
                <p class="font-h3 font-color-primary" v-if="title2">{{ title2 }}</p>
                <p class="font-h3 alt" v-if="subline2">{{ subline2 }}</p>
                <HelperHtmlRenderer v-if="lead2" :htmlContent="lead2" :additionalClasses="'font-lead'" />
                <HelperHtmlRenderer v-if="text2" :htmlContent="text2" />
              </div>
            </div>

            <div class="Scrollytelling__content_section" id="part3">
              <div class="etx-text Text">
                <p class="font-h3 font-color-primary" v-if="title3">{{ title3 }}</p>
                <p class="font-h3 alt" v-if="subline3">{{ subline3 }}</p>
                <HelperHtmlRenderer v-if="lead3" :htmlContent="lead3" :additionalClasses="'font-lead'" />
                <HelperHtmlRenderer v-if="text3" :htmlContent="text3" />
              </div>
            </div>

            <div class="Scrollytelling__content_section" id="part4">
              <div class="etx-text Text">
                <p class="font-h3 font-color-primary" v-if="title4">{{ title4 }}</p>
                <p class="font-h3 alt" v-if="subline4">{{ subline4 }}</p>
                <HelperHtmlRenderer v-if="lead4" :htmlContent="lead4" :additionalClasses="'font-lead'" />
                <HelperHtmlRenderer v-if="text4" :htmlContent="text4" />
              </div>
            </div>

            <div class="Scrollytelling__content_section" id="part5">
              <div class="etx-text Text">
                <p class="font-h3 font-color-primary" v-if="title5">{{ title5 }}</p>
                <p class="font-h3 alt" v-if="subline5">{{ subline5 }}</p>
                <HelperHtmlRenderer v-if="lead5" :htmlContent="lead5" :additionalClasses="'font-lead'" />
                <HelperHtmlRenderer v-if="text5" :htmlContent="text5" />
              </div>

              <div class="etx-spacer h-75 tab-s:h-0"></div>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>